(function ProgressEventPolyfill(PE) {
  const DEFAULTS = { lengthComputable: false, loaded: 0, total: 0 };
  let KEYS;
  const TYPES = ["abort", "error", "load", "loadstart", "progress", "timeout"];

  function defineGetter(property, value) {
    Object.defineProperty(this, property, {
      enumerable: true,
      get: function () { return value; }
    });
  }

  function ProgressEvent(type, eventInit = {}) {
    if (TYPES.indexOf(type) === -1) {
      throw new TypeError("Invalid event type");
    }

    const self = this;

    self.name = self.constructor.name;
    self.type = type;
    (KEYS = KEYS || Object.keys(DEFAULTS)).forEach(function (property) {
      let value = DEFAULTS[property];

      if (Object.prototype.hasOwnProperty.call(eventInit, property)) {
        value = eventInit[property];
      }

      defineGetter.call(self, property, value);
    });
  }

  if (typeof PE !== "function") {
    Object.setPrototypeOf(ProgressEvent.prototype, Event);
    ProgressEvent.prototype.constructor = ProgressEvent;
    window.ProgressEvent = ProgressEvent;
  }
})(window.ProgressEvent);



// WEBPACK FOOTER //
// ./core/progress-event.js